import { render } from "./EditJson.vue?vue&type=template&id=4f18aa28&scoped=true"
import script from "./EditJson.vue?vue&type=script&lang=js"
export * from "./EditJson.vue?vue&type=script&lang=js"

import "./EditJson.vue?vue&type=style&index=0&id=4f18aa28&scoped=true&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f18aa28"]])

export default __exports__